import * as React from 'react';
import styled from 'styled-components';
import { rem, rgba } from 'polished';
import {
  FlexCol,
  FlexColCenterVertical,
  FlexRow,
  FlexRowCenterVertical,
  TextP,
} from '../../..';
import { CountSetter } from '../Product/CountSetter';
import { StockInfo } from '../Product/StockInfo';
import { BigButtonWithRequest } from '../Product/BigButtonWithRequest';
import { FavoriteCompare } from './FavoriteCompare';
import { Watching } from '../Product/Watching';
import { __ } from 'react-i18n';
import { formatPrice, prop, round } from '../../../utilities';
import { SmallLoader } from '../General/SmallLoader';
import { Button } from '../General/Button';
import { scrollToElement } from '../Cart/utilities';

interface Props {
  product: any;
  price: string;
  currency: string;
}

function ProductTabGiftCardLabel({ product, price, currency }: Props) {
  const currentGiftCard = product?.product_detail?.available_gift_cards?.length
    ? product.product_detail.available_gift_cards[0]
    : null;
  if (!currentGiftCard) {
    return <></>;
  }

  // calculate price
  let finalPrice = parseFloat(price);
  if (currentGiftCard.discount !== null) {
    finalPrice = finalPrice - finalPrice * (currentGiftCard.discount / 100);
    return (
      <>
        <Wrapper>
          <PriceText> {formatPrice(finalPrice, currency, 2)} </PriceText>
          <InfoText>
            {' '}
            {__('Cena so zľavovým kódom')}{' '}
            <InfoTextCode>{currentGiftCard.card_number}</InfoTextCode>{' '}
          </InfoText>
        </Wrapper>
      </>
    );
  } else if (currentGiftCard.freeshipping) {
    return (
      <>
        <Wrapper>
          <InfoText>
            {' '}
            {__('Doprava zdarma s kódom')}{' '}
            <InfoTextCode>{currentGiftCard.card_number}</InfoTextCode>{' '}
          </InfoText>
        </Wrapper>
      </>
    );
  } else {
    return <></>;
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${({ theme }) =>
    theme.product.availableGiftLabelBackgroundColor};
  padding-left: ${rem(15)};
  padding-right: ${rem(15)};
  padding-top: ${rem(10)};
  padding-bottom: ${rem(10)};
  width: 100%;
`;

const InfoText = styled.span`
  font-size: ${rem(11)};
  color: ${({ theme }) => theme.product.availableGiftLabelTextColor};
`;

const InfoTextCode = styled.span`
  font-weight: bold;
`;

const PriceText = styled.span`
  font-size: ${rem(15)};
  font-weight: 500;
  color: ${({ theme }) => theme.product.availableGiftLabelPriceColor};
  white-space: nowrap;
`;

export { ProductTabGiftCardLabel };
